import { User, UserStatus } from '../../entities-next/user'

export type UserState = {
  readonly isFetching: boolean
  readonly items: IdIndexedUser
}

export type UserMatchFilter = {
  status?: UserStatus
}

export type IdIndexedUser = {
  readonly [userId: number]: User
}

export const USER_STORE_ID = 'user'
